const pick = require('../utils/pick');
const { objectOperator } = require('../utils/spread');
const { getConfiguration } = require('../config');
const { CDN_HEALTH } = require('../../constants/initiatives');
const {
  RESOURCE_SIZE, RESOURCE_FAILURE, RESOURCE_SUCCESS, X_CDN, AVAILABILITY_FAILURE,
} = require('../../constants/metrics');
const { METRICS } = require('../../constants/configurations');


const requiredMetrics = [X_CDN];

const preparePayload = (settings, data) => {
  const metrics = getConfiguration(METRICS, CDN_HEALTH);
  const collection = pick(data, metrics);

  if (!Object.keys(collection).length) {
    throw new Error('Metrics not found');
  }

  const collectionKeys = Object.keys(collection);
  if (!requiredMetrics.every(metric => collectionKeys.indexOf(metric) !== -1)) {
    throw new Error('Metrics missing');
  }

  const failures = (data[AVAILABILITY_FAILURE] || []).length;
  const success = collection[RESOURCE_SIZE] - failures;

  return {
    name: CDN_HEALTH,
    data: objectOperator({
      collection,
      [RESOURCE_FAILURE]: failures,
      [RESOURCE_SUCCESS]: success,
    }),
  };
};

module.exports = preparePayload;
